import * as React from "react";
import { UitkField } from "../uitk-react-field/index.js";
import { classNames } from "../uitk-react-utils/index.js";
import { useForkRef } from "./fork-ref.js";
import { useLocalization } from "../egencia-provider/localization-context.js";
const primaryText = (minInvalid, maxInvalid, minCharacters, maxCharacters, numCharacters, l10n) => {
  if (minInvalid) {
    return l10n.formatText("textarea.minInvalid.text", minCharacters.characterAmount - numCharacters);
  } else if (maxInvalid) {
    return l10n.formatText("textarea.maxInvalid.text", numCharacters - maxCharacters.characterAmount);
  } else {
    return minCharacters && !minCharacters.errorOnly ? l10n.formatText("textarea.minInstruction.text", minCharacters.characterAmount) : void 0;
  }
};
const secondaryText = (maxInvalid, maxCharacters, numCharacters) => {
  if (maxCharacters) {
    if (maxCharacters.errorOnly) {
      return maxInvalid ? `${numCharacters}/${maxCharacters.characterAmount}` : void 0;
    } else {
      return `${numCharacters}/${maxCharacters.characterAmount}`;
    }
  } else {
    return void 0;
  }
};
export const UitkTextArea = React.forwardRef(
  ({
    onChange,
    maxRows,
    minRows = 2,
    minCharacters,
    maxCharacters,
    value,
    disabled,
    hasBorder,
    hasFloatedLabel,
    hasVisibleLabel,
    id,
    instruction,
    invalid,
    label,
    placeholder,
    readOnly,
    required = false,
    ...other
  }, ref) => {
    const uitkFieldProps = {
      disabled,
      hasBorder,
      hasFloatedLabel,
      hasVisibleLabel,
      id,
      invalid,
      instruction,
      label,
      placeholder,
      readOnly,
      required
    };
    const inputRef = React.useRef(null);
    const handleRef = useForkRef(ref, inputRef);
    const renders = React.useRef(0);
    const textAreaClassNames = classNames("uitk-field-textarea", other.className);
    const l10n = useLocalization();
    if ((minCharacters || maxCharacters) && !invalid) {
      const minInvalid = minCharacters && value.length < minCharacters.characterAmount;
      const maxInvalid = maxCharacters && value.length > maxCharacters.characterAmount;
      const minMaxText = {
        primary: primaryText(minInvalid, maxInvalid, minCharacters, maxCharacters, value.length, l10n),
        secondary: secondaryText(maxInvalid, maxCharacters, value.length)
      };
      if (minInvalid || maxInvalid) {
        uitkFieldProps.invalid = minMaxText;
      } else {
        uitkFieldProps.instruction = minMaxText;
      }
    }
    const handleChange = (event) => {
      renders.current = 0;
      if (onChange) {
        onChange(event);
      }
    };
    return /* @__PURE__ */ React.createElement(UitkField, { ...uitkFieldProps }, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        "aria-required": required,
        "aria-invalid": !!invalid,
        className: textAreaClassNames,
        id,
        onChange: handleChange,
        placeholder,
        ref: handleRef,
        rows: minRows,
        ...other,
        value
      }
    ));
  }
);
UitkTextArea.displayName = "UitkTextArea";
